import 'bootstrap/dist/css/bootstrap.min.css';
import FloatingLabelInput from './FloatingLabelInput.component';
import { FloatingInputBasicProps } from './FloatingProps';

const ReadonlyFloatingLabelInput = ({ label, className, value, onChange }: FloatingInputBasicProps) => {
  return <FloatingLabelInput {...{ label, className, value, onChange }} readonly={true} />;
};

export default ReadonlyFloatingLabelInput;
